var React = require('react');

function IconCheckSlim (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33301 8.10564L5.73495 12.6667L14.6663 3.33337","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconCheckSlim.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconCheckSlim;

IconCheckSlim.default = IconCheckSlim;
